import { useEffect } from 'react';
import { create } from 'zustand';

type Tema = 'aydinlik' | 'karanlik';

interface TemaDurumu {
  tema: Tema;
  degistir: () => void;
  ayarla: (t: Tema) => void;
}

const TEMA_ANAHTAR = 'emanetx.tema';

function baslangic(): Tema {
  if (typeof window === 'undefined') return 'aydinlik';
  const kayitli = window.localStorage.getItem(TEMA_ANAHTAR) as Tema | null;
  if (kayitli === 'karanlik' || kayitli === 'aydinlik') return kayitli;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'karanlik' : 'aydinlik';
}

export const useTemaStore = create<TemaDurumu>((set, get) => ({
  tema: baslangic(),
  degistir: () => {
    const yeni: Tema = get().tema === 'karanlik' ? 'aydinlik' : 'karanlik';
    set({ tema: yeni });
    if (typeof window !== 'undefined') window.localStorage.setItem(TEMA_ANAHTAR, yeni);
  },
  ayarla: (t) => {
    set({ tema: t });
    if (typeof window !== 'undefined') window.localStorage.setItem(TEMA_ANAHTAR, t);
  },
}));

/** root document'a "dark" class'i takip eder. App.tsx icinde bir kere cagrilir. */
export function useTemaEtkisi() {
  const tema = useTemaStore((s) => s.tema);
  useEffect(() => {
    const kok = document.documentElement;
    if (tema === 'karanlik') kok.classList.add('dark');
    else kok.classList.remove('dark');
  }, [tema]);
}
